import { createBlenderChartMap } from './chart.js';
import { COLLISION as exchange } from './exchange-collision.js';
import { COLLISION as bubble } from './bubble-collision.js';
import { COLLISION as hft } from './hft-collision.js';
import { DT } from './constants.js';
export function createReviewedArena(id, opts) {
    const [key, name, asset] = id === 'grid' ? ['exchange', 'The Exchange', exchange]
        : id === 'drift' ? ['bubble', 'Bubble', bubble] : ['hft', 'HFT Floor', hft];
    const map = createBlenderChartMap(asset, { width: opts?.radius === undefined ? 1 : opts.radius / asset.radius, playerCount: opts?.playerCount });
    map.id = id;
    map.name = name;
    map.visual = { ...map.visual, builder: key === 'hft' ? 'hft' : 'chart', asset: `/models/arenas/${key}-v1.json` };
    if (id === 'foundry')
        for (const p of map.platforms) {
            const row = /^hft_belt_([0-3])_[0-2]$/.exec(p.partId ?? '');
            const group = /^hft_cross_[01]_[0-4]$/.test(p.partId ?? '') ? 2 : row ? Number(row[1]) % 2 : undefined;
            if (p.surface.kind === 'conveyor' && group !== undefined) {
                p.surface = { ...p.surface, speed: [8, 12, 16][group] / DT, hftRouteGroup: group };
            }
        }
    return map;
}
//# sourceMappingURL=reviewed-arenas.js.map